import classNames from "classnames"

import { ControlIntent } from "./ControlIntent"
import { ControlStateOptions } from "./ControlStateOptions"
import { determineControlBoxClass } from "./determineControlBoxClass"

/**
 *  Determine CSS classes for the line control box based on the passed state options.
 *  A line control should be single line control.
 */
export function determineLineControlBoxClass(state: ControlStateOptions, intent: ControlIntent = "editable") {
  return classNames(
    // normally, all our line controls span the full width of the parent container
    "w-full",
    // all our line controls have a height of 38px. This doesn't come from the Design System,
    // but from the code-base itself.
    "h-[38px]",
    determineControlBoxClass(state, intent)
  )
}
